//下载excel文件
import {CommonImgApi} from '@/modules/server-api/commodity-sys/common';
import axios from 'axios';
import { Loading } from 'element-ui';
import {Local_Storage,session_Storage} from "@/store/local.storage";


//url：下载链接； param:参数； fileName下载的文件名称
export const downloadExcel = async function(url, param, fileName  ) {
   addHeader();
   showLoaing();
   await CommonImgApi.downlod(url,param, true).then(res => {
      const blob = new Blob([res.result.data]);
      //因后台文件名乱码，故从前台传，如果没有则取后台传来的值
      if(!fileName){
        let fileName1 = res.result.headers["fileName"];
        let fileName2 = res.result.headers['content-disposition'] ? res.result.headers['content-disposition'].split("filename=")[1] : null;
        fileName = fileName1 || fileName2;
      }
      //创建a元素
      const elink = document.createElement("a");
      elink.style.display = "none";
      elink.href = URL.createObjectURL(blob);
      elink.setAttribute('id', 'downloadLink')
      elink.setAttribute('download', fileName);
      document.body.appendChild(elink);
      elink.click();

      // 释放URL 对象
      URL.revokeObjectURL(elink.href);
      document.body.removeChild(elink);
      hideLoading();
  });
};

//下载文件模板
export const downloadFileTemplate = async function(url, fileName) {
  addHeader();
  showLoaing();
  await CommonImgApi.downloadTemplate(url).then(res => {
     const blob = new Blob([res.result.data]);
     //因后台文件名乱码，故从前台传，如果没有则取后台传来的值
     if(!fileName){
       let fileName1 = res.result.headers["fileName"];
       let fileName2 = res.result.headers['content-disposition'] ? res.result.headers['content-disposition'].split("filename=")[1] : null;
       fileName = fileName1 || fileName2;
     }
     //创建a元素
     const elink = document.createElement("a");
     elink.style.display = "none";
     elink.href = URL.createObjectURL(blob);
     elink.setAttribute('id', 'downloadLink')
     elink.setAttribute('download', fileName);
     document.body.appendChild(elink);
     elink.click();

     // 释放URL 对象
     URL.revokeObjectURL(elink.href);
     document.body.removeChild(elink);
    hideLoading();
 });
};

//导入
// export const importExcel = function(url, fileObj){
//   addHeader({enctype: 'multipart/form-data'});
//   CommonImgApi.testPost(url,fileObj).then(res => {
//     console.log(res);
//   });
// }

//添加token
let addHeader = function(param){
  //添加header
  axios.interceptors.request.use(
   config => {
       let savedSession = session_Storage.getSession();
       // console.log(['request-config', config.url]);
       let token = savedSession.token || '';
       config.headers.Authorization =token;
       if(param){
         config.headers = {...config.headers, ...param}
       }
       return config
   },
   error => {
       return Promise.reject(error)
   }
 )
}

// 加载loading
let loading;
let loadingCount = 0;
function start() {
  loading = Loading.service({
    lock: true,
    text: '',
    background: 'rgba(255,255,255,0.7)'
  })
}
function end() {
  loading.close();
}
function showLoaing() {
  if (loadingCount == 0) {
    start();
  }
  loadingCount++
}

function hideLoading() {
  loadingCount--;
  if (loadingCount == 0) {
    end()
  }
}
